import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { TemplateService } from '../../services/template.service';
import { HttpParams } from '@angular/common/http';
import * as _ from 'lodash';
import * as moment from 'moment';
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-saletax',
  templateUrl: './saletax.component.html',
  styleUrls: ['./saletax.component.scss'],
  providers: [TemplateService]
})
export class SaleTaxComponent implements OnInit {

  step = 0;
  items = [
    {label: 'รายการที่ยังไม่บันทึก'},
    {label: 'รายการที่บันทึกแล้ว'}
  ];

  constructor(private apiService: ApiService,
              private template: TemplateService,
              private route: ActivatedRoute) {
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/saletax/saletax.component.ts